module.exports = __webpack_public_path__ + "img/header_background.a1abf163.png";